let map, geocoder, infoWindow, storeMarkers = [], searchMarker, cityCircle, currentPos = null;

async function initMap() {
    //@ts-ignore
    const { Map } = await google.maps.importLibrary("maps");
    const { Place } = await google.maps.importLibrary("places")
//     const { Circle } = await google.maps.importLibrary("circle")

    map = new Map(document.getElementById("stores-map"), storesOptions);
    geocoder = new google.maps.Geocoder();

//     var service = new Place("stores-map");
//     infoWindow = new google.maps.InfoWindow();

    for (let i = 0; i < stores.length; i++) {
        let label = i + 1
       addStoreMarker(i, stores[i])
    }

    // if (navigator.geolocation && currentPos == null) {
    //     navigator.geolocation.getCurrentPosition(
    //         (position) => {
    //             currentPos = {
    //                 lat: position.coords.latitude,
    //                 lng: position.coords.longitude,
    //             }
    //             let storeArticles = document.querySelectorAll('.carde-store')
    //             if(storeArticles.length > 0) {
    //                 storeArticles.forEach((article)=>{
    //                     let pos = {
    //                         lat: article.dataset.latitude,
    //                         lng: article.dataset.longitude,
    //                     }
    //                     let dst = calculateDistance(currentPos, pos)
    //                     article.querySelector('.distance span').innerHTML = dst
    //                 })
    //             }
    //         }
    //     );
    // }
}

initMap();

function addStoreMarker(i, store) {
    let label = i + 1
    if(store.info) {
        infoWindow = new google.maps.InfoWindow({
            content: store.info.text,
            ariaLabel: store.info.title,
        });
        infoWindow.setPosition(new google.maps.LatLng(store.latitude, store.longitude));
//         infoWindow.setTitle("Uluru")
//         infoWindow.setContent("Location found.");
        infoWindow.open(map);
    } else {
        const marker = new google.maps.Marker({
            position: new google.maps.LatLng(store.latitude, store.longitude),
            icon: storesOptions.icon,
            // label:{
            //     text: store.name,
            //     color: 'white',
            //     fontWeight: 'bold',
            //     fontSize: '29px',
            // },
            map: map,
        });
        storeMarkers.push(marker)
        google.maps.event.addListener(marker, 'click', function() {
          infoWindow = new google.maps.InfoWindow({
            content: `
              <div><b>${store.name}</b></div>
              <div>${store.address}</div>
              <div>${store.zip}, ${store.city}, ${store.country}</div>
              <div>${store.link}</div>
              `,
              ariaLabel: store.name,
          });
          infoWindow.setPosition(new google.maps.LatLng(store.latitude, store.longitude));
//         infoWindow.setTitle("Uluru")
//         infoWindow.setContent("Location found.");
          infoWindow.open(map);
        });
    }
}

let findStoresList = document.querySelector('.stores-list .list')
let findStoresListTitles = document.querySelectorAll('.stores-list .title')
let findStoresButton = document.querySelector('.store-search .button')
let findStoresInput = document.querySelector('.store-search input')

if(findStoresButton) {
    findStoresButton.addEventListener('click', (event)=>{
        searchPlaces()
    })
}

if(findStoresListTitles.length > 0) {
    findStoresListTitles.forEach((title)=>{
        title.addEventListener('click', (event)=>{
            let card = title.closest('.card-store')
            let pos = {
                lat: card.dataset.latitude,
                lng: card.dataset.longitude,
            }
            map.setCenter(new google.maps.LatLng(pos.lat, pos.lng),)
            console.log(card)
        })
    })
}

if(findStoresInput) {
//     findStoresInput.addEventListener('keypress', (event)=>{
//         console.log(findStoresInput.value.length)
//         if(findStoresInput.value.length > 3) {
//             searchPlaces()
//         }
//     })
}

function dropSearchPin(pos, radius) {
    if(searchMarker) {
        searchMarker.setMap(null)
    }
    searchMarker = new google.maps.Marker({
        position: new google.maps.LatLng(pos.lat, pos.lng),
        map: map,
    });
    if(cityCircle) {
        cityCircle.setMap(null)
    }
    cityCircle = new google.maps.Circle({
      strokeColor: "#FF0000",
      strokeOpacity: 0.2,
      strokeWeight: 2,
      fillColor: "#FF0000",
      fillOpacity: 0.05,
      map,
      center: pos,
      radius: radius * 1609.34,
    });
}

function searchPlaces() {
    let address = findStoresInput.value
    for (let i = 0; i < storeMarkers.length; i++) {
        storeMarkers[i].setMap(null);
    }
    storeMarkers = [];
    geocoder.geocode( {
        'address': address,
        componentRestrictions: {
            // country: 'fr'
        }
    }, function(results, status) {
      if (status == 'OK') {
        map.setCenter(results[0].geometry.location);
        map.setZoom(12);
//         var marker = new google.maps.Marker({
//             map: map,
//             position: results[0].geometry.location
//         });
        let pos2 = {
            lat: results[0].geometry.location.lat(),
            lng: results[0].geometry.location.lng(),
        }
        dropSearchPin(pos2, 10)
        let j = 0;
        let closeStores = []
        for (let i = 0; i < stores.length; i++) {
            let label = i + 1
            let pos1 = {
                lat: stores[i].latitude,
                lng: stores[i].longitude,
            }
            let dstLabel = calculateDistance(pos1, pos2);
            let dst = parseFloat(dstLabel.replace(/[^\d.]/g, ''));
            if(dst <= 50.0) {
                stores[i].dst = dst
                closeStores[j++] = stores[i]
//                 addStoreMarker(j, stores[i])
                document.querySelector('.card-store[data-id="' + stores[i].id + '"]').classList.remove('hidden')
                document.querySelector('.card-store[data-id="' + stores[i].id + '"]').dataset.distance = dst
                // document.querySelector('.card-store[data-id="' + stores[i].id + '"] .distance span').innerHTML = dstLabel
            } else {
                document.querySelector('.card-store[data-id="' + stores[i].id + '"]').classList.add('hidden')
                document.querySelector('.card-store[data-id="' + stores[i].id + '"]').style.order = 0
            }
        }
        if(closeStores.length == 0) {
            j = 0;
            map.setZoom(10);
            dropSearchPin(pos2, 25)
            for (let i = 0; i < stores.length; i++) {
                let label = i + 1
                let pos1 = {
                    lat: stores[i].latitude,
                    lng: stores[i].longitude,
                }
                let dstLabel = calculateDistance(pos1, pos2);
                let dst = parseFloat(dstLabel.replace(/[^\d.]/g, ''));
                if(dst <= 10.0) {
                    stores[i].dst = dst
                    closeStores[j++] = stores[i]
    //                 addStoreMarker(j, stores[i])
                    document.querySelector('.card-store[data-id="' + stores[i].id + '"]').classList.remove('hidden')
                    // document.querySelector('.card-store[data-id="' + stores[i].id + '"] .distance span').innerHTML = dstLabel
                } else {
                    document.querySelector('.card-store[data-id="' + stores[i].id + '"]').classList.add('hidden')
                    document.querySelector('.card-store[data-id="' + stores[i].id + '"]').style.order = 0
                }
            }
        }
        closeStores.sort((x, y) => {
            if (x.order > y.order) return -1;
            if (x.dst > y.dst) return 1;
            if (x.dst < y.dst) return -1;
            return 0;
        } )
        
        j = 0;
        closeStores.forEach((store)=>{
            addStoreMarker(j, store)
            j++;
            // document.querySelector('.article-store[data-id="' + store.id + '"] .index').innerHTML = j
            document.querySelector('.card-store[data-id="' + store.id + '"]').style.order = -100 + j
        })
      } else {
        console.log('Geocode was not successful for the following reason: ' + status);
        for (let i = 0; i < storeMarkers.length; i++) {
            storeMarkers[i].setMap(null);
        }
        storeMarkers = [];
        let j = 0;
        let pos2 = null
        stores.forEach((store)=>{
            if(store.name.toLowerCase().search(address.toLowerCase()) != -1) {
                console.log(store)
                j++;
                document.querySelector('.card-store[data-id="' + store.id + '"]').classList.remove('hidden')
                addStoreMarker(j, store)
                document.querySelector('.card-store[data-id="' + store.id + '"]').style.order = -100 + j
                pos2 = {
                    lat: parseFloat(store.latitude),
                    lng: parseFloat(store.longitude),
                }
            } else {
                document.querySelector('.card-store[data-id="' + store.id + '"]').classList.add('hidden')
                document.querySelector('.card-store[data-id="' + store.id + '"]').style.order = 0
            }
        })
        if(pos2 != null) {
            // dropSearchPin(pos2, 10)
            map.setCenter(new google.maps.LatLng(pos2.lat, pos2.lng))
            map.setZoom(12);
        }
      }
    });
}

function searchStores() {
    let search = findStoresInput.value.toLowerCase()
    let stores = findStoresList.querySelectorAll('.article-store')
    if(stores.length > 0) {
        stores.forEach((store)=>{
            store.remove()
        })
    }
    for (let i = 0; i < storeMarkers.length; i++) {
        storeMarkers[i].setMap(null);
    }
    storeMarkers = [];
    fetch(`?sections=main-blog-stores-json&q=${search}`)
        .then((response) => response.json())
        .then((responseJson) => {
            const html = new DOMParser().parseFromString(responseJson['main-blog-stores-json'], 'text/html')
            const items = html.querySelectorAll('.article-store')
            if(items.length > 0) {
                let position = 0
                items.forEach((item)=>{
                    let ok = false
                    if( item.dataset.zip.search(search) != -1
                        || item.dataset.city.search(search) != -1
                        || item.dataset.state.search(search) != -1
                    ) {
                        ok = true
                    }
                    if(ok) {
                        position++
                        item.querySelector('.index').innerHTML = position
                        findStoresList.append(item)
                        addStoreMarker(position - 1, {
                            url: item.dataset.url,
                            longitude: item.dataset.longitude,
                            latitude: item.dataset.latitude
                        })
                    }
                })
            }
        })
    ;
}
function calculateDistance(pos1, pos2) {
    var R = 3958.8; // Radius of the Earth in miles
    var rlat1 = pos1.lat * (Math.PI/180); // Convert degrees to radians
    var rlat2 = pos2.lat * (Math.PI/180); // Convert degrees to radians
    var difflat = rlat2-rlat1; // Radian difference (latitudes)
    var difflon = (pos2.lng-pos1.lng) * (Math.PI/180); // Radian difference (longitudes)

    var d = 2 * R * Math.asin(Math.sqrt(Math.sin(difflat/2)*Math.sin(difflat/2)+Math.cos(rlat1)*Math.cos(rlat2)*Math.sin(difflon/2)*Math.sin(difflon/2)));
    d = Math.round((d + Number.EPSILON) * 100) / 100
    return d.toString() + ' miles';
}
// function getDirections(button) {
//     // Try HTML5 geolocation.
//     if (navigator.geolocation) {
//         navigator.geolocation.getCurrentPosition(
//             (position) => {
//                 const pos = {
//                     lat: position.coords.latitude,
//                     lng: position.coords.longitude,
//                 };
// 
//                 infoWindow.setPosition(pos);
//                 infoWindow.setContent("Location found.");
//                 infoWindow.open(map);
//                 map.setCenter(pos);
//             },
//             () => {
//                 handleLocationError(true, infoWindow, map.getCenter());
//             }
//         );
//     } else {
//         // Browser doesn't support Geolocation
//         handleLocationError(false, infoWindow, map.getCenter());
//     }
// }
// 
// function handleLocationError(browserHasGeolocation, infoWindow, pos) {
//   infoWindow.setPosition(pos);
//   infoWindow.setContent(
//     browserHasGeolocation
//       ? "Error: The Geolocation service failed."
//       : "Error: Your browser doesn't support geolocation."
//   );
//   infoWindow.open(map);
// }